/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { connect } from 'react-redux';
import { reorderContents, addContent, selectContent, updateNoLiveContent } from 'state/actions/embedsState/embedManagementState/content_status';
import { displayModal } from 'state/actions/modal_status';
import { setEmbedProperty } from 'state/actions/embedsState/embedManagementState/selected_embed_status';
// actual presentational component that will utilize application state and actions (will be exported after being infused with state/actions)
import OrganizeContentPage from 'pages/dashboard/embeds/management/organize/organize';



/* ========== ~~~~~~~~~~ PAGE : ORGANIZE : PARENT ~~~~~~~~~~ ========== */
// CONTAINER COMPONENT
// interacts with redux (store of application state)
// infuses child component (imported above) with state & actions by mapping and then connecting them

// map state
const mapStateToProps = ({ embedsState }) => {
    const contentStatus = embedsState.embedManagementState.contentStatus;
    const activeContents = Object.values(contentStatus.contents).filter(content => content.contentLive === true);
    const inactiveContents = Object.values(contentStatus.contents).filter(content => content.contentLive === false);
    return {
        location: embedsState.embedManagementState.selectedEmbedStatus.selectedEmbedData.location,
        contentOrder: embedsState.embedManagementState.selectedEmbedStatus.selectedEmbedData.contentOrder,
        numOfContents: Object.keys(embedsState.embedManagementState.contentStatus.contents).length,
        contents: embedsState.embedManagementState.contentStatus.contents,
        numberOfActiveContents: activeContents.length,
        numberOfInactiveContents: inactiveContents.length
    }
};
// map actions
const mapDispatchToProps = dispatch => ({
    displayModal: (isVisible, contentToDisplay, showCloseButton) => {
        dispatch(displayModal(isVisible, contentToDisplay, showCloseButton))
    },
    reorderContents: (liveContents, inactiveContents) => dispatch(reorderContents(liveContents, inactiveContents)),
    setEmbedProperty: (property, value) => dispatch(setEmbedProperty(property, value)),
    addContent: contentType => dispatch(addContent(contentType)),
    selectContent: contentId => dispatch(selectContent(contentId)),
    updateNoLiveContent: bool => dispatch(updateNoLiveContent(bool))
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// utilizes "connect" functionality from redux in order to infuse state/actions as props to child component
export default connect(
	mapStateToProps,
    mapDispatchToProps
)(OrganizeContentPage);